import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { News } from '../news.model';
import { NewsService } from '../news.service';

@Component({
  selector: 'app-press',
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.css']
})
export class PressComponent implements OnInit {

  //declare variables
  news: any[] = [];
  intCount: number = 0;
  strSearch: string = '';

  //inject services
  constructor(private ns: NewsService, private router: Router) { }

  //initialize the component
  ngOnInit(): void {
    this.refresh();
  }

  //refresh the data
  refresh() {
    this.ns.get().subscribe(data => {
      this.news = data;
      this.intCount = this.news.length;
    })
  }

  //navigate to the provided URL
  navigate(strUrl) {
    window.open(strUrl, "_blank");
  }

  //executes the search
  filter() {

  }

}
